import { render, staticRenderFns } from "./InspectionViewLogs.vue?vue&type=template&id=35d6e978"
import script from "./InspectionViewLogs.vue?vue&type=script&lang=js"
export * from "./InspectionViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports